// extracted by mini-css-extract-plugin
module.exports = {"Form":"Questions_Form__2p6mV","Questions":"Questions_Questions__PlgA2"};